import React from "react";
import logoimg from "./assests/logo.png";
import "./index.css";
import { Link } from "react-router-dom";
export default function Navbar() {
  // <div className="container-fluid ">
  //     <div className="row">
  //         <div className="col-10 mx-auto">

  //         </div>
  //     </div>

  // </div>

  return (
    <div className="container-fluid nav-div">
      <div className="row">
        <div className="col-10 mx-auto">
          <nav className="navbar navbar-expand-lg navbar-light ">
            <div className="container-fluid">
              <Link className="navbar-brand" to="/">
                <img src={logoimg} alt="company logo"/>
              </Link>
              <button
                className="navbar-toggler custom-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              <div
                className="collapse navbar-collapse"
                id="navbarSupportedContent"
              >
                <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
                  <li className="nav-item mx-2">
                    <Link className="nav-link active" aria-current="page" to="/">
                      Home
                    </Link>
                  </li>
                  <li className="nav-item mx-2">
                    <Link className="nav-link" to="/services">
                      Services
                    </Link>
                  </li>
                  <li className="nav-item mx-2">
                    <Link className="nav-link" to="/products">
                      Products
                    </Link>
                  </li>
                  <li className="nav-item mx-2">
                    <Link className="nav-link" to="/signup">
                      SignUp
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  );
}
